import axios from "axios";
import {createURL} from "./client";

// getSubscriptionStatus проверяет, подписан ли пользователь на уведомления
export async function getSubscriptionStatus() {
    return await axios.get(createURL("/api/subscription"));
}

// subscribe подписывает пользователя на уведомления
export async function subscribe() {
    return await axios.post(createURL("/api/subscription"));
}

// unsubscribe отписывает пользователя от уведомлений
export async function unsubscribe() {
    return await axios.delete(createURL("/api/subscription"));
}
